import { InjectionToken } from '@angular/core';
import * as mixpanel from 'mixpanel-browser';

export function mixpanelFactory(): Mixpanel {
  return mixpanel;
}

export const MIXPANEL = new InjectionToken<Mixpanel>('mixpanel');
